<template>
	<list-page icone="mdi-account-cash" titulo="Doador" @novo="Novo()" @atualizar="Atualizar()">
		<template v-slot:corpo>

			<v-expansion-panels focusable>
				<v-expansion-panel>
					<v-expansion-panel-header>Filtros</v-expansion-panel-header>
					<v-expansion-panel-content class="mt-5">
						<v-row>
							<v-col cols="12" md="1">
								<v-text-field v-model="filter.codigo" label="Código" dense outlined />
							</v-col>
							<v-col cols="12" md="2">
								<v-text-field v-model="filter.cpfCnpj" label="CPF/CNPJ" v-mask="mskCpfCnpj" counter="18"
									maxlength="18" @blur="filter.cpfCnpj = (filter.cpfCnpj || '').toLocaleUpperCase()"
									dense outlined />
							</v-col>
							<v-col cols="12" md="6">
								<v-text-field v-model="filter.nome" label="Nome" dense outlined />
							</v-col>
							<v-col cols="12" md="3">
								<v-select v-model="filter.situacao" label="Situação" :items="situacoes" item-value="key"
									item-text="value" dense outlined />
							</v-col>
							<v-col cols="12" sm="6" md="4">
								<v-select v-model="filter.regiaoId" label="Região/Grupo" :items="regioes"
									item-value="id" item-text="nome" dense outlined />
							</v-col>
						</v-row>
						<v-row>
							<v-spacer></v-spacer>
							<v-btn color="accent" @click="Atualizar()">Consultar</v-btn>
						</v-row>
					</v-expansion-panel-content>
				</v-expansion-panel>
			</v-expansion-panels>

			<div class="cards-totalizadores-container my-4">
				<v-card v-for="card in cardsTotalizadores" :key="card.chave" class="pa-3 totalizador-card" outlined
					:style="`background-color: ${card.corFundo}; border-color: ${card.corBorda};`">
					<div class="d-flex">
						<v-avatar size="28" :color="card.corIconeFundo" class="mr-3">
							<v-icon small :color="card.corIcone">{{ card.icone }}</v-icon>
						</v-avatar>
						<div>
							<div class="totalizador-titulo">{{ card.titulo }}</div>
							<div class="totalizador-valor">{{ card.valor }}</div>
							<div class="totalizador-subtitulo">{{ card.subtitulo }}</div>
						</div>
					</div>
				</v-card>
			</div>

			<v-data-table id="tabela" :headers="headers" :items="lista" :options.sync="options"
				:server-items-length="totalLista" :loading="loading" class="elevation-1">
				<template v-slot:[`item.actions`]="{ item }">

					<v-tooltip right>
						<template v-slot:activator="{ on }">
							<v-icon small @click="Editar(item)" v-on="on">mdi-pencil</v-icon>
						</template>
						<span>Editar</span>
					</v-tooltip>

					<v-tooltip right>
						<template v-slot:activator="{ on }">
							<v-icon small @click="Excluir(item)" v-on="on">mdi-delete</v-icon>
						</template>
						<span>Excluir</span>
					</v-tooltip>

				</template>

				<template v-slot:[`item.doacaoProposta`]="{ item }">
					{{ !!item.doacaoProposta ? Number(item.doacaoProposta).toMoeda(true) : '' }}
				</template>

			</v-data-table>

			<v-overlay :value="primeiraCarga">
				<v-progress-circular indeterminate size="64"></v-progress-circular>
			</v-overlay>

			<cadastro-doador v-model="dialogCadastro" :item="item" @fechou="dialogCadastro = false"
				@salvou="Atualizar()" />

		</template>
	</list-page>
</template>
<script>
import { MskCnpjAlfa } from '@/core/domain/shared/Global';
import DoadorService from '@/core/services/doacao/DoadorService';
import Doador from '@/core/domain/doacao/Doador';
import { SituacaoEnumService } from '../../../core/services/geral';
import { RegiaoService } from '@/core/services/doacao';
import ListPage from "@/components/shared/ListPage";

const totalizadoresPadrao = () => ({
	totalDoadores: 0,
	totalDoadoresAtivos: 0,
	totalDoadoresInativos: 0,
	valorTotalDoacaoAtivosGeramRecebivel: 0
});

export default {
	extends: ListPage,
	data: () => ({
		headers: [
			{ text: '', value: 'actions', sortable: false },
			{ text: '#', value: 'id', type: 'number' },
			{ text: 'CPF/CNPJ', value: 'cpfCnpj' },
			{ text: 'Nome', value: 'nome' },
			{ text: 'Telefone', value: 'telefone' },
			{ text: 'Celular', value: 'celular' },
			{ text: 'E-mail', value: 'email' },
			{ text: 'Dia bom', value: 'diaBom' },
			{ text: 'Valor', value: 'doacaoProposta' }
		],
		situacoes: [],
		filter: {
			cpfCnpj: '',
			codigo: null,
			nome: '',
			situacao: '',
			regiaoId: null
		},
		primeiraCarga: true,
		loadingTotalizadores: false,
		totalizadores: totalizadoresPadrao(),
		mskCpfCnpj: MskCnpjAlfa,
	}),
	computed: {
		cardsTotalizadores() {
			return [
				{
					chave: 'total-doadores',
					titulo: 'Total de doadores',
					valor: this.loadingTotalizadores ? '-' : this.totalizadores.totalDoadores,
					subtitulo: 'Quantidade total filtrada',
					icone: 'mdi-account-group-outline',
					corFundo: '#edf2f7',
					corBorda: '#d4dde8',
					corIconeFundo: '#dfe7f1',
					corIcone: '#3f5d7a'
				},
				{
					chave: 'total-doadores-ativos',
					titulo: 'Total de ativos',
					valor: this.loadingTotalizadores ? '-' : this.totalizadores.totalDoadoresAtivos,
					subtitulo: 'Situação ativa',
					icone: 'mdi-account-check-outline',
					corFundo: '#eaf6ef',
					corBorda: '#d3e8dc',
					corIconeFundo: '#dceddf',
					corIcone: '#2f6f4f'
				},
				{
					chave: 'total-doadores-inativos',
					titulo: 'Total de inativos',
					valor: this.loadingTotalizadores ? '-' : this.totalizadores.totalDoadoresInativos,
					subtitulo: 'Situação inativa',
					icone: 'mdi-account-cancel-outline',
					corFundo: '#fdeeee',
					corBorda: '#f3d7d7',
					corIconeFundo: '#f8dfdf',
					corIcone: '#a94442'
				},
				{
					chave: 'valor-total-doacao',
					titulo: 'Total de doação',
					valor: this.loadingTotalizadores ? '-' : Number(this.totalizadores.valorTotalDoacaoAtivosGeramRecebivel || 0).toMoeda(true),
					subtitulo: 'Ativos com gerar recebível',
					icone: 'mdi-currency-usd-circle-outline',
					corFundo: '#fff5e9',
					corBorda: '#f0dfc8',
					corIconeFundo: '#f8e9d4',
					corIcone: '#8a5a21'
				}
			];
		}
	},
	watch: {
		lista: function () {
			if (this.primeiraCarga)
				this.primeiraCarga = false;
		},
	},
	created() {
		this.service = new DoadorService();
	},
	methods: {
		MontarFiltro() {
			return {
				codigo: this.filter.codigo,
				cpfCnpj: this.filter.cpfCnpj,
				nome: this.filter.nome,
				situacao: this.filter.situacao,
				regiaoId: this.filter.regiaoId
			};
		},
		Listar(filter, include) {
			this.loading = true;
			this.loadingTotalizadores = true;

			const filtro = filter || this.MontarFiltro();
			const { sortBy, sortDesc, page, itemsPerPage } = this.options;

			this.service.ListarComFiltro(page, itemsPerPage, sortBy, sortDesc, this.search, this.headers, filtro, include)
				.then(
					res => {
						this.lista = res.data.items;
						this.totalLista = res.data.count;
					},
					err => {
						this.$swal('Aviso', err.response.data, 'error');
					}
				)
				.finally(() => {
					this.loading = false;
				});

			this.service.TotalizadoresComFiltro(this.search, this.headers, filtro, include)
				.then(
					res => {
						this.totalizadores = res.data;
					},
					err => {
						this.totalizadores = totalizadoresPadrao();
						this.$swal('Aviso', err.response.data, 'error');
					}
				)
				.finally(() => {
					this.loadingTotalizadores = false;
				});
		},
		Novo() {
			this.NovoCadastro(new Doador());
		},
		Editar(item) {
			this.service.ObterPorId(item.id, "Contatos, Indicador, Projeto")
				.then(
					res => {
						this.EditarCadastro(new Doador(res.data));
					},
					err => this.$swal('Aviso', err.response.data, 'error')
				)
		},
		Atualizar() {
			this.Listar(this.MontarFiltro());
		}
	},
	mounted() {

		const situacaoEnumService = new SituacaoEnumService();
		situacaoEnumService.Listar()
			.then(
				res => {
					this.situacoes = res.data;
					this.situacoes.unshift({
						key: '',
						value: 'TODOS'
					});
				},
				err => {
					this.$swal('Aviso', err.message, 'error');
				}
			);

		const regiaoService = new RegiaoService();
		regiaoService.ListarTudo()
			.then(
				res => {
					this.regioes = res.data.items;
					this.regioes.unshift({
						id: null,
						nome: '---NENHUM---'
					})
				},
				err => {
					this.$swal('Aviso', err.message, 'error');
				}
			);

		this.Atualizar();
	}
}
</script>
<style scoped>
.totalizador-card {
	border-width: 1px;
	border-style: solid;
	min-height: 90px;
	width: 100%;
}

.cards-totalizadores-container {
	display: grid;
	grid-template-columns: repeat(4, minmax(0, 1fr));
	gap: clamp(8px, 0.8vw, 14px);
}

@media (max-width: 1400px) {
	.cards-totalizadores-container {
		grid-template-columns: repeat(3, minmax(0, 1fr));
	}
}

@media (max-width: 960px) {
	.cards-totalizadores-container {
		grid-template-columns: repeat(2, minmax(0, 1fr));
	}
}

@media (max-width: 600px) {
	.cards-totalizadores-container {
		grid-template-columns: 1fr;
	}
}

.totalizador-titulo {
	font-size: 10px;
	color: #5f6a77;
	font-weight: 600;
	line-height: 1.2;
}

.totalizador-valor {
	font-size: 20px;
	font-weight: 700;
	color: #202b37;
	line-height: 1.1;
}

.totalizador-subtitulo {
	font-size: 10px;
	color: #6b7280;
	margin-top: 2px;
}
</style>
